<template>
  <div v-show='isActive' class="Step">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'SStep',
      required: true
    },
    icon: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      isActive: false
    }
  }
}
</script>

<style scoped>

  .Step{
    width: inherit;
  }
</style>